//noScroll
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-accordion li:first .ttl').addClass('is-open');
    $('.js-open').click(function(){
      var index = $(this).index();
      $(this).toggleClass('is-open');
      $(this).next().slideToggle(300);
      $('.js-open').not($(this)).next().slideUp();
      $('.js-open').not($(this)).removeClass('is-open');
      // $('.map-img figure').eq(index).addClass('active');
    });
  }
}

//noScroll
class Calendar {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let date = new Date();

    $('.js-change-date').html(`${date.getFullYear()}年 ${date.getMonth() + 1}月`)

    let swiper = new Swiper(".mySwiper", {
      initialSlide: $(`[data-year="${date.getFullYear()}"][data-month="${date.getMonth() + 1}"]`).index(),
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      spaceBetween: 50,
      speed: 500,
    });

    swiper.on('slideChangeTransitionStart', function () {
      $('.js-change-date').html($('.swiper-slide-active').data('date'));
    });
  }
}
//noScroll
class Concept {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var swiper = new Swiper('.swiper1', {             
      loop:true,
      speed: 6000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      spaceBetween: 10,
      slidesPerView: 1.2,

      breakpoints: {
        // 768px以上の場合
        960: {
          slidesPerView: 3.2,
          spaceBetween: 10,
        }
      },
    })
    var swiper = new Swiper('.slide1', {             
      slidesPerView: 1,
      spaceBetween: 30,
      effect: 'fade',
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      // breakpoints: {
      //   769: {
      //     slidesPerView: 3.2,
      //     spaceBetween: 30,
      //   }
      // }
    })
  }
}

//noScroll
class Facility {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var swiper = new Swiper('.slide1', {             
      slidesPerView: 1,
      spaceBetween: 30,
      effect: 'fade',
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: '.swiper-pagination1',
        clickable: true
      },
      // breakpoints: {
      //   769: {
      //     slidesPerView: 3.2,
      //     spaceBetween: 30,
      //   }
      // }
    })
    var swiper = new Swiper('.slide2', {             
      slidesPerView: 1,
      spaceBetween: 30,
      effect: 'fade',
      autoplay: {
        delay: 4000,
      },
      pagination: {
        el: '.swiper-pagination2',
        clickable: true
      },
      // breakpoints: {
      //   769: {
      //     slidesPerView: 3.2,
      //     spaceBetween: 30,
      //   }
      // }
    })
  }
}

// globals

const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})
//noScroll
class Information {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const $js_tab = $('.js-tab-title');
    const $js_tab_target = $('.js-tab-img');
    const cls = 'active';

    $js_tab.on('click', function () {
      const this_category = $(this).data('title');
      $js_tab_target.removeClass(cls);
          
      $js_tab_target.each(function () {
        const target_data = $(this).data('img');
        if (this_category === target_data) {
          $(this).addClass(cls);
        }
      });
    
    });
  }
}

//noScroll
class News {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    /* news　カテゴリー選択  */
    const newsCatSelect = () => {

      const newsCats = document.querySelectorAll(".js-cat");
      const newsArticle = document.querySelectorAll(".news-article")
  
        newsCats.forEach((cat, i) => {
          cat.addEventListener("click", () => {
            const isActiveCat = document.querySelector(".is-catActive")
            const isShowCat = document.querySelector(".is-catShow")
            
            isActiveCat.classList.remove("is-catActive")
            cat.classList.add("is-catActive")
  
  
            isShowCat.classList.remove("is-catShow")
            newsArticle[i].classList.add("is-catShow")
          })
        })
      }
      newsCatSelect();
  
  }
}

//noScroll
class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    /* news　カテゴリー選択  */
    const newsCatSelect = () => {

    const newsCats = document.querySelectorAll(".js-cat");
    const newsArticle = document.querySelectorAll(".news-article")

      newsCats.forEach((cat, i) => {
        cat.addEventListener("click", () => {
          const isActiveCat = document.querySelector(".is-catActive")
          const isShowCat = document.querySelector(".is-catShow")
          
          isActiveCat.classList.remove("is-catActive")
          cat.classList.add("is-catActive")


          isShowCat.classList.remove("is-catShow")
          newsArticle[i].classList.add("is-catShow")
        })
      })
    }
    newsCatSelect();

    /* 施設写真スライダー  */
    const swiper = new Swiper(".top-swiper", {

      loop:true,
      speed: 6000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      spaceBetween: 10,
      slidesPerView: 1.2,


      breakpoints: {

        // 768px以上の場合
        960: {
          slidesPerView: 3.2,
          spaceBetween: 10,
        }
      },

    });
    
    /* 背景固定  */
    
    gsap.registerPlugin(ScrollTrigger);
    
    ScrollTrigger.create({
    trigger: ".guide-hotSpring",
    pin: true,
    start: "top center",
    end: 'bottom 0%',
    // endTrigger: ".p-top__news",
    toggleClass: {targets: ".guide-hotSpring", className: "is-active"}, //クラスをつけたり、外したりできる
    // markers: true,
    });
    
    
    /* MVアニメーション */
    const mvAnimation = () => {
    let tl = gsap.timeline({repeat: 0, repeatDelay: 1});
    
    tl.fromTo(".ttl-01", .7,
      {
        autoAlpha: 0,
        scale: 0.8,
    
      }, {
        autoAlpha: 1,
        scale: 1,
    
      }
    );
    tl.fromTo('.ttl-02', .7, {
      autoAlpha: 0,
      scale: 0.8,
    
    }, {
      autoAlpha: 1,
      scale: 1,
    
    })
    tl.fromTo('.ttl-03', .7, {
      autoAlpha: 0,
      scale: 0.8,
    
    }, {
      autoAlpha: 1,
      scale: 1,
    
    },
    )
    tl.fromTo('.mv-logo', .7, {
      autoAlpha: 0,
    
    
    }, {
      autoAlpha: 1,
    },
    )
    tl.fromTo('.mv-sideTtl', .7, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      onComplete: function() {
        $('html').addClass('is-nav-active');
      }
    },"<"
    )
    tl.fromTo('.l-header__inner', .7, {
      autoAlpha: 0,
      y: -50, // 垂直方向
    }, {
      autoAlpha: 1,
      y: 0, // 垂直方向
    },
    )
    tl.fromTo('.l-header-sns, .l-header__sns', .7, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      onComplete: function() {
        $(".l-header__inner, .l-header-sns, .l-header__sns").addClass('is-active');
      }
    },
    )
    tl.fromTo('.mv-scroll', .3, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
    
    },
    "<"
    )
    
    }

    $(window).scroll(function() {
      if($('html').hasClass('is-scroll') == false && $('html').hasClass('is-nav-active') == false) {
        let tl_s = gsap.timeline({repeat: 0, repeatDelay: 1});

        tl_s.fromTo('.l-header__inner', .01, {
          autoAlpha: 1,
        
        }, {
          autoAlpha: 1,
          onComplete: function() {
            $('html').addClass('is-nav-active');
          }
        },
        )
        tl_s.fromTo('.l-header__inner', .7, {
          autoAlpha: 0,
          y: -50, // 垂直方向
        
        }, {
          autoAlpha: 1,
          y: 0, // 垂直方向
        },
        )
        tl_s.fromTo('.l-header-sns, .l-header__sns', .7, {
          autoAlpha: 0,
        }, {
          autoAlpha: 1,
          onComplete: function() {
            $(".l-header__inner, .l-header-sns, .l-header__sns").addClass('is-active');
          }
        },
        )
        $('html').addClass('is-scroll');
      }
    })
    
    
    const firstViewFlag = () => {
    
    const keyName = 'firstView';
    
    /// そのcookie値を取得
    const value = document.cookie
      .split(/;\s*/)
      .find(row => {
        const [key, value] = row.split("=")
        return key === keyName
      }).split('=')[1];
    
    if(value === "true"){
      setTimeout(mvAnimation,2000)
    }else{
      setTimeout(mvAnimation,600)
    }
    
    }
    
    firstViewFlag();
  }
}



var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
//noScroll
class HeaderNavEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    jQuery(function($){

      if (window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches) {
        $(window).on('scroll', function(){
          let point = window.pageYOffset;
          let dispHeight = $(".c-page-footer").offset().top;
          if(point + 100 > dispHeight ){
            $(".js-header").fadeOut(300)
          }else{
            $(".js-header").fadeIn(300)
          }
        });
      }
      else if (window.matchMedia('(min-width: 768px)').matches) {
        $(window).on('scroll', function(){
          let point = window.pageYOffset;
          let dispHeight = $(".c-page-footer").offset().top;
          if(point + 700 > dispHeight ){
            $(".js-headerNav").fadeOut(300)
            $(".l-header-sns").fadeOut(300)
          }else{
            $(".js-headerNav").fadeIn(300)
            $(".l-header-sns").fadeIn(300)
          }
        });
      }

      if (window.matchMedia('(max-width: 767px)').matches) {

        $(window).on('scroll', function(){
          let point = window.pageYOffset;
          let dispHeight = $(".c-page-footer").offset().top;
          if(point + 100 > dispHeight ){
            $(".js-header").fadeOut(300)
          }else{
            $(".js-header").fadeIn(300)
          }
        });
      }
    });

    jQuery(document).ready(function($) {

    });

    $(function(){
      if (window.matchMedia('(max-width: 850px)').matches) {
        const HeaderContainer = document.querySelector(".js-headerNav")
        const openNav = document.querySelectorAll(".l-header__click, .l-header__overlay")

        openNav.forEach(function(el) {
          el.addEventListener("click", () => {
            HeaderContainer.classList.toggle("is-open")
            document.querySelector(".l-header__bg-topParts").classList.toggle("is-wide")
            document.querySelector(".l-header__overlay").classList.toggle("is-open")
            document.querySelector("body").classList.toggle("is-open")
  
            if(HeaderContainer.classList.contains("is-open")){
              document.querySelector(".l-header__btnText.open").classList.remove("is-show")
              document.querySelector(".l-header__btnText.close").classList.add("is-show")
              setTimeout(() => {
                document.querySelector(".l-header__list").classList.add("is-show")
                document.querySelector(".l-header__link").classList.add("is-show")
              }, 500);
            }else{
              document.querySelector(".l-header__btnText.open").classList.add("is-show")
              document.querySelector(".l-header__btnText.close").classList.remove("is-show")
              document.querySelector(".l-header__list").classList.remove("is-show")
              document.querySelector(".l-header__link").classList.remove("is-show")
            }
          })
        })
      }
    })
  }
}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  // let smoothScroll = new SmoothScroll('');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let top = new Top('p-top');
  let haderNavEvent  = new HeaderNavEvent('js-headerNav');
  let facility = new Facility('p-facility');
  let concept = new Concept('p-concept');
  let accordion = new Accordion('js-accordion');
  let news = new News('p-news');
  let information = new Information('p-information');
  let calendar = new Calendar('p-information');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });

